export const MOST_RECENT_EDUCATION_MESSAGE_LS_KEY = 'most_recent_education_message';
export const MOST_RECENT_POINTS_MESSAGE_LS_KEY = 'most_recent_points_message';
export const MOST_RECENT_HOMEPAGE_MESSAGE_LS_KEY = 'most_recent_homepage_message';
export const MOST_RECENT_POST_CHECKOUT_MESSAGE_LS_KEY = 'most_recent_post_checkout_message';
export const CURRENT_TPN_STATUS_LS_KEY = 'tpn_status_code';
export const STATUS_MAINTAINED_LS_KEY = 'tpn_status_maintained';

export const PLACEMENT_TYPE_EDUCATION = 'education';
export const PLACEMENT_TYPE_POINTS = 'points';
export const PLACEMENT_TYPE_HOMEPAGE = 'homepage';
export const PLACEMENT_TYPE_POST_CHECKOUT = 'post-checkout';

export const placementTypeStorageKeyMap = {
    [PLACEMENT_TYPE_EDUCATION]: MOST_RECENT_EDUCATION_MESSAGE_LS_KEY,
    [PLACEMENT_TYPE_POINTS]: MOST_RECENT_POINTS_MESSAGE_LS_KEY,
    [PLACEMENT_TYPE_HOMEPAGE]: MOST_RECENT_HOMEPAGE_MESSAGE_LS_KEY,
    [PLACEMENT_TYPE_POST_CHECKOUT]: MOST_RECENT_POST_CHECKOUT_MESSAGE_LS_KEY,
} as const;

export type PlacementType =
    | typeof PLACEMENT_TYPE_EDUCATION
    | typeof PLACEMENT_TYPE_POINTS
    | typeof PLACEMENT_TYPE_HOMEPAGE
    | typeof PLACEMENT_TYPE_POST_CHECKOUT;
